export const appParams = {
	page: 0,
	pageSize: 20,
	query: '',
	sortProp: 'id',
	sortValue: 'desc',
};

// Artifacts
export const artifactParams = {
	...appParams,
	sortProp: 'createdAt',
	sortValue: 'desc',
};

export const artifactDetailParams = {
	include: ['activities'],
};

// Workspace
export const workspaceParams = {
	include: ['location', 'setup', 'subscription(usage).[billingPeriod, card, price.[meteredPrice], product]'],
};

// Activity
export const activityParams = {
	...appParams,
	sortProp: 'createdAt',
	sortValue: 'desc',
};

// Banks
export const bankParams = {
	...appParams,
	sortProp: 'default',
	sortValue: 'desc',
};

// Banks
export const bookmarkParams = {
	...appParams,
};

// Branchs
export const branchParams = {
	...appParams,
	sortProp: 'default',
	sortValue: 'desc',
};

// Cards
export const cardParams = {
	...appParams,
	sortProp: 'default',
	sortValue: 'desc',
};

// Campaigns
export const campaignParams = {
	...appParams,
};

export const campaignDetailParams = {
	include: [],
};

// Categories
export const categoryParams = {
	...appParams,
	include: ['editorial', 'stats'],
	sortProp: 'categories.id',
	sortValue: 'desc',
};

// Collections
export const collectionParams = {
	...appParams,
	include: ['bookmarks(preview)', 'editorial', 'stats'],
	sortProp: 'collections.position',
	sortValue: 'asc',
};

export const collectionDetailParams = {
	include: ['bookmarks(preview)', 'editorial', 'stats'],
};

// Comments
export const commentParams = {
	...appParams,
	sortProp: 'comments.createdAt',
	sortValue: 'asc',
	include: ['meta', 'replies'],
};

// Contacts
export const contactParams = {
	...appParams,
	include: [''],
	sortProp: 'name',
	sortValue: 'asc',
};

// Content
export const contentParams = {
	...appParams,
};

export const contentDetailParams = {
	include: [],
};

// Coupons
export const couponParams = {
	...appParams,
	sortProp: 'name',
	sortValue: 'desc',
};

export const couponDetailParams = {
	include: [],
};

// Credits
export const creditParams = {
	...appParams,
	include: ['storageUsage.project'],
	sortProp: 'createdAt',
	sortValue: 'desc',
};

export const creditDetailParams = {
	include: ['storageUsage.project'],
};

// Configs
export const configDetailParams = {
	include: ['credentials', 'lifecycle', 'runtime'],
};

// Deploys
export const deployParams = {
	...appParams,
	include: ['config.[lifecycle,runtime]', 'currentRelease', 'limits', 'vm'],
	sortProp: 'createdAt',
	sortValue: 'desc',
};

export const deployDetailParams = {
	include: [
		'config.[credentials,lifecycle,runtime,services(image)]',
		'currentRelease.[artifact,sessions]',
		'limits',
		'metrics',
		'releases.[artifact,sessions]',
		'sessions.[release]',
		'views.[session]',
		'vm',
	],
};

export const deployReleaseParams = {
	...appParams,
	include: ['artifact', 'sessions'],
	sortProp: 'createdAt',
	sortValue: 'desc',
};

export const deploySessionParams = {
	...appParams,
	include: ['deploy', 'release', 'views'],
	sortProp: 'createdAt',
	sortValue: 'desc',
};

export const deploySessionDetailParams = {
	include: ['deploy', 'release', 'views'],
};

export const deployViewParams = {
	...appParams,
	include: ['session'],
	sortProp: 'createdAt',
	sortValue: 'desc',
};

export const inferenceSessionParams = {
	...appParams,
	include: ['credit', 'deploy', 'model', 'workspace', 'user'],
	sortProp: 'createdAt',
	sortValue: 'desc',
};

export const inferenceSessionDetailParams = {
	include: ['credit', 'deploy', 'model', 'workspace', 'user'],
};

export const projectOperatorRunParams = {
	...appParams,
	include: ['branch.project', 'model', 'checkpoint'],
	sortProp: 'project_operator_runs.createdAt',
	sortValue: 'desc',
};

export const inferenceModelParams = {
	...appParams,
	sortProp: 'inference_models.position',
	sortValue: 'asc',
};

export const agentSkillParams = {
	...appParams,
	include: [],
	sortProp: 'agent_skills.id',
	sortValue: 'desc',
};

export const agentSkillDetailParams = {
	include: [],
};

export const agentDesignParams = {
	...appParams,
	include: [],
	sortProp: 'agent_designs.id',
	sortValue: 'desc',
};

export const agentDesignDetailParams = {
	include: [],
};

// Downloads
export const downloadParams = {
	...appParams,
	include: ['project'],
};

// Editorial
export const editorialParams = {
	['editorial.featured']: true,
	sortProp: 'editorial.position',
	sortValue: 'asc',
	include: ['editorial'],
};

// Credentials
export const credentialParams = {
	...appParams,
	sortProp: 'position',
	sortValue: 'asc',
};

// Followers
export const followerParams = {
	...appParams,
	include: [],
};

export const followerDetailParams = {
	include: [],
};

// Followings
export const followingParams = {
	...appParams,
	include: [],
};

export const followingrDetailParams = {
	include: [],
};

// Github
export const githubParams = {
	page: 1,
	pageSize: 20,
	query: '',
	sortProp: 'full_name',
	sortValue: 'asc',
};

// Images
export const imageParams = {
	...appParams,
	include: [''],
	sortProp: 'name',
	sortValue: 'asc',
};

export const imageDetailParams = {
	include: [''],
};

// Runtimes
export const runtimeParams = {
	...appParams,
	sortProp: 'capacityUnits',
	sortValue: 'asc',
};

export const runtimeDetailParams = {
	include: [],
};

// Inquiries
export const inquiryParams = {
	...appParams,
	include: ['user'],
};

// Invoices
export const invoiceParams = {
	...appParams,
	include: ['card', 'subscription.[price,product]'],
};

export const invoiceDetailParams = {
	include: ['card', 'subscription.[price,product]'],
};

// Leads
export const leadParams = {
	...appParams,
};

export const leadDetailParams = {
	include: [],
};

// Ledger
export const ledgerParams = {
	...appParams,
	include: [],
	sortProp: 'ledgers.id',
	sortValue: 'asc',
};

export const ledgerDetailParams = {
	include: ['transfer'],
};

// Library
export const libraryParams = {
	...appParams,
	include: ['bookmarks', 'stats'],
	sortProp: 'collections.position',
	sortValue: 'asc',
};

// Licenses
export const licenseParams = {
	...appParams,
	include: ['editorial'],
	sortProp: 'licenses.name',
	sortValue: 'asc',
};

// Media
export const mediaParams = {
	...appParams,
	sortProp: 'createdAt',
	sortValue: 'desc',
	include: [''],
};

// Members
export const memberParams = {
	...appParams,
	sortProp: '',
	sortValue: 'asc',
	include: [''],
};

export const conversationMessageParams = {
	context: 'usage',
	include: [
		'author',
		'approvals.decidedBy',
		'attachments',
		'replyToMessage.author',
		'targets.[user,project,workspace]',
		'queuedModel',
		'targetRun.[model]',
		'run.[model]',
		'latestRun.[model]',
	],
	pageSize: '*',
	sortValue: 'asc',
};

// Newsletters
export const newsletterParams = {
	...appParams,
	include: [''],
};

export const newsletterDetailParams = {
	include: ['templates'],
};

// Notes
export const noteParams = {
	include: [],
};

// Notifications
export const notificationParams = {
	...appParams,
	include: ['projectTransfer'],
};

// Owner
export const ownerParams = {
	...appParams,
	include: ['editorial', 'stats'],
	sortProp: 'name',
	sortValue: 'asc',
};

export const ownerDetailParams = {
	include: ['editorial', 'location', 'setup', 'stats'],
};

// Payouts
export const payoutParams = {
	...appParams,
	include: ['bank'],
};

export const payoutDetailParams = {
	include: ['bank', 'transfers'],
};

// Pins
export const pinParams = {
	...appParams,
	sortProp: 'id',
};

// Pipelines
export const pipelineParams = {
	...appParams,
	sortProp: 'id',
	sortValue: 'desc',
};

// Projects
export const projectParams = {
	...appParams,
	include: [
		'connectors.[connector,workspaceConnector]',
		'conversation.[latestMessage.[promptApprovals,run]]',
		'deploy',
		'folder',
		'github',
		'projectOwner',
		'sandbox',
		'stats',
		'type',
	],
	sortProp: 'projects.updatedAt',
	sortValue: 'desc',
};

export const projectOperationParams = {
	...appParams,
	include: ['branch'],
	sortProp: 'project_operations.id',
	sortValue: 'desc',
};

export const projectTypeParams = {
	...appParams,
	pageSize: '*',
	sortProp: 'project_types.position',
	sortValue: 'asc',
};

export const agentTypeParams = {
	...appParams,
	pageSize: '*',
	sortProp: 'agent_types.position',
	sortValue: 'asc',
};

export const agentPromptParams = {
	...appParams,
	pageSize: 3,
	random: true,
};

export const projectPromptParams = {
	...appParams,
	pageSize: 3,
	random: true,
};

export const projectDetailParams = {
	include: [
		'preferences.model',
		'design.design',
		'skills.skill',
		'tools.tool',
		'mcps.mcp',
		'connectors.[connector,workspaceConnector]',
		'agents.[model,owner]',
		'branch',
		'branches.stats',
		'collaborators.[user]',
		'conversation',
		'deploy.[config.[credentials,lifecycle,runtime,services]]',
		'externalTransfers',
		'github',
		'stats',
		'sandbox.[config.[credentials,lifecycle,runtime,services,currentVersion]]',
		'template',
		'type',
		'projectOwner',
	],
};

// Templates
export const templateParams = {
	...appParams,
	include: ['categories', 'editorial', 'license', 'project.type', 'stats'],
	sortProp: 'templates.updatedAt',
	sortValue: 'desc',
};

export const templateDetailParams = {
	include: [
		'categories',
		'deploy.[config.services,currentRelease]',
		'editorial',
		'license',
		'stats',
		'project.[connectors.[connector.provider],type]',
		'quality',
		'setup',
	],
};

// Products
export const productParams = {
	...appParams,
	include: ['prices.[meteredPrice,seatPrice]'],
	sortProp: 'id',
	sortValue: 'asc',
};

// Prospects
export const prospectParams = {
	...appParams,
	include: [''],
	sortProp: 'prospects.name',
	sortValue: 'asc',
};

// Prices
export const priceParams = {
	...appParams,
	include: ['meteredPrice', 'seatPrice', 'product'],
	sortProp: 'amount',
	sortValue: 'asc',
};

export const priceDetailParams = {
	include: ['meteredPrice', 'seatPrice', 'product'],
};

// Products
export const productDetailParams = {
	include: ['prices'],
};

// Replies
export const replyParams = {
	...appParams,
	include: ['attachments', 'meta'],
	sortProp: 'messages.createdAt',
	sortValue: 'asc',
};

// Search
export const searchParams = {
	...appParams,
	sortProp: 'count',
	sortValue: 'desc',
};

// Session
export const sessionParams = {
	include: [
		'githubIdentity',
		'googleIdentity',
		'location',
		'workspaces.[location, subscription.[price, product]]',
		'setup',
		'settings',
		'subscription(usage).[billingPeriod, card, price.[meteredPrice], product]',
	],
};

// Subscriptions
export const subscriptionParams = {
	...appParams,
	include: ['price', 'product'],
};

export const subscriptionDetailParams = {
	include: ['billingPeriod', 'card', 'price.[meteredPrice,seatPrice]', 'product'],
};

// Workspaces
export const workspaceSearchParams = {
	...appParams,
	include: ['editorial', 'stats'],
	sortProp: 'workspaces.name',
	sortValue: 'asc',
};

export const workspaceDetailParams = {
	include: ['editorial', 'location', 'members(preview)', 'setup', 'stats'],
};

// Tokens
export const tokenParams = {
	...appParams,
};

// Transfers
export const transferParams = {
	...appParams,
	include: [],
};

export const transferDetailParams = {
	include: ['ledgers', 'payout'],
};

// Users
export const userParams = {
	...appParams,
	include: ['editorial', 'stats'],
	sortProp: 'users.name',
	sortValue: 'asc',
};

export const userDetailParams = {
	include: ['editorial', 'location', 'setup', 'stats', 'workspaces(preview)'],
};

// Views
export const viewParams = {
	...appParams,
};
